import styled from 'styled-components';

import ButtonBase from '../ButtonBase';
import ListItemIcon from '../ListItemIcon';
import SvgIcon from '../SvgIcon';

const ListItemButton = styled(ButtonBase)`
  justify-content: flex-start;
  align-items: flex-start;
  text-align: left;
  font-size: ${props => props.textFontSize || 14}px;

  span {
    line-height: inherit;
  }

  &:hover,
  &:focus {
    color: #144271;
    background: transparent;

    ${ListItemIcon} {
      ${SvgIcon} {
        fill: #144271;
      }
    }
  }
`;
export default ListItemButton;
